import React from 'react';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { TagBase } from '@milanote/roma';
import Icon from '../../../../../../components/icons/Icon';
import Button from '../../../../../../components/buttons/Button';

type Props = {
    tag: Tag;
    handleClickTag: (tag: Tag) => void;
    handleClickEdit: (tag: Tag) => void;
    isSelected?: boolean;
    size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
};

const TagListElement: React.FC<Props> = ({ tag, handleClickTag, handleClickEdit, isSelected, size }) => {
    const { id, name, color } = tag;

    return (
        <div id={`tag-${id}`} className="TagListElement mb-1 w-full flex items-center justify-between">
            <div className="cursor-pointer" onClick={() => handleClickTag(tag)}>
                <TagBase size={size} color={color}>
                    {name}
                </TagBase>
            </div>
            <div className="flex gap-1">
                {isSelected && <Icon name="block-style-tick" />}
                <Button onClick={() => handleClickEdit(tag)}>...</Button>
            </div>
        </div>
    );
};

export default TagListElement;
